export enum AsbestosTargetType {
  ASB = 'asbestos',
  KMF = 'kmf',
}
